module.exports = __webpack_public_path__ + "static/1-35fc9782e5ef3c24442a1532a553a0d6.jpg";